import { render, staticRenderFns } from "./T4AutoResearcherBox.vue?vue&type=template&id=0f04fb3e&scoped=true"
import script from "./T4AutoResearcherBox.vue?vue&type=script&lang=js"
export * from "./T4AutoResearcherBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04fb3e",
  null
  
)

export default component.exports